export default {"src":"/_next/static/media/bibi-logo.534b1c63.svg","height":862,"width":767,"blurWidth":0,"blurHeight":0};